import { Size } from '@anm/api/types';
import PreviewTitleCard, { PreviewTitleCardProps } from '@anm/components/PreviewTitleCard';
import Tooltip from '@anm/components/Tooltip';
import compactProps from '@anm/helpers/compactProps';
import formatTime from '@anm/helpers/time/formatTime';
import { FC } from 'react';

import Crown from '../../Crown';

import TooltipContent from './TooltipContent';
import VideoBlockWrapper, { DurationBadge } from './Wrapper';

export type VideoBlockProps = {
  slug: string;
  size: Size;
  preview: string;
  templateId: string;
  isPremium: boolean;
  displayName: string;
  link: PreviewTitleCardProps['link'];
  videoUrl?: string;
  duration?: number;
  // isFirstRenderPreview?: boolean;
};

const VideoBlock: FC<VideoBlockProps> = ({ slug, duration, isPremium, templateId, displayName, ...previewProps }) => {
  const route = previewProps.link?.route || '';
  const { params } = previewProps.link || {};

  const link = {
    route,
    params: {
      ...{ pageName: slug || templateId },
      ...compactProps(params)
    }
  };

  return (
    <VideoBlockWrapper>
      {isPremium && (
        <Tooltip withArrow delayShow={200} variant="black" direction="to-top" renderContent={() => <TooltipContent />}>
          <Crown />
        </Tooltip>
      )}
      <PreviewTitleCard
        isLink
        weight="bold"
        title={displayName}
        {...{ ...previewProps, link }}
        renderDurationBadge={() => (duration ? <DurationBadge>{formatTime(duration)}</DurationBadge> : null)}
      />
    </VideoBlockWrapper>
  );
};

export default VideoBlock;
